import { PaymentsService } from '@/services/payments.service'

export default {
  namespaced: true,
  state: {
    unlinked: 0,
  },

  actions: {
    getUnlinkedCount({ commit }) {
      return PaymentsService.unlinkedCount()
        .then((response) => commit('SET_PAYMENTS_UNLINKED_COUNT', response.data.content))
        .catch((error) =>
          commit('toast/NEW', { type: 'error', message: error.message }, { root: true })
        )
    },
  },

  getters: {
    unlinked(state) {
      return state.unlinked
    },
  },

  mutations: {
    SET_PAYMENTS_UNLINKED_COUNT(state, data) {
      state.unlinked = data
    },
  },
}
